import React from "react";

const ToggleableIcon = ({ state }) => (
    <div className={`toggleable-icon ${state ? 'toggleable-icon--opened' : 'toggleable-icon--closed'}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 10L12 17L5 10" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>
);

export default ToggleableIcon;
